export default "__VITE_ASSET__xO1Wo7Uo__"